module.exports = __webpack_public_path__ + "img/deepseek-slogan@3x.393d83f1.png";